// src/api/returns.js
import { supabase } from "../supabaseClient";

// يجيب سطور البيع اللي لسه فيها متبقي للمرتجع (من الـRPC)
export async function fetchSaleDetailsRemaining(customerId) {
  const { data, error } = await supabase.rpc("get_sale_details_remaining", {
    p_customer_id: customerId,
  });
  if (error) throw error;
  return data;
}

// ينشئ المرتجع (من الـRPC)
export async function createReturnNote({
  customer_id,
  original_sale_id,
  reason,
  items,
}) {
  const payload = {
    customer_id,
    original_sale_id,
    reason,
    items,
    currency: "EGP",
  };
  const { data, error } = await supabase.rpc("create_return_note", { payload });
  if (error) throw error;
  return data; // { return_id, total_refund }
}

// يجيب المرتجع بالتفصيل للطباعة (header + details + customer)
export async function getReturnNoteById(returnId) {
  const { data: header, error: hErr } = await supabase
    .from("return_note")
    .select("id, date, reason, total_refund, customer_id, original_sale_id")
    .eq("id", returnId)
    .maybeSingle();
  if (hErr) throw hErr;
  if (!header) throw new Error("Return note not found or access denied.");

  const { data: details, error: dErr } = await supabase
    .from("return_note_details")
    .select(
      "sale_detail_id, block_id, showroom_id, slabs_returned, area_returned_m2, price_per_m2"
    )
    .eq("return_id", returnId)
    .order("id", { ascending: true });
  if (dErr) throw dErr;

  const { data: customer } = await supabase
    .from("customer")
    .select("name, phone")
    .eq("id", header.customer_id)
    .maybeSingle();

  return { ...header, details: details || [], customer: customer || {} };
}

// يجيب مرتجعات الصالة مجمّعة لكل return_id (للعرض بالسالب)
export async function fetchReturnsForShowroom(showroomId) {
  const { data, error } = await supabase
    .from("return_note_details")
    .select(
      `
        return_id,
        showroom_id,
        line_refund_amount,
        return_note:return_id ( id, date, customer_id, original_sale_id )
      `
    )
    .eq("showroom_id", showroomId)
    .order("return_id", { ascending: false });
  if (error) throw error;

  const map = new Map();
  for (const row of data || []) {
    const r = row.return_note;
    if (!r) continue;
    if (!map.has(r.id)) {
      map.set(r.id, {
        id: r.id,
        date: r.date,
        customer_id: r.customer_id,
        original_sale_id: r.original_sale_id, // <— مهم
        total_refund_for_showroom: 0,
      });
    }
    map.get(r.id).total_refund_for_showroom += Number(
      row.line_refund_amount || 0
    );
  }
  return Array.from(map.values());
}
